exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit-profile-header{padding-left:13rem}.edit-profile-header-cancel-btn{margin-left:5px}.edit-profile-modal-body{padding-top:0}#edit-profile-modal{max-width:800px}@media(max-width: 576px){#edit-profile-modal{max-width:100%;margin:.5rem}}@media(min-width: 577px){#edit-profile-modal{max-width:98%}}@media(min-width: 900px){#edit-profile-modal{max-width:800px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/modals/EditProfileModal/styles.scss
// module id = 773
// module chunks = 0